import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import Img from '../../../../components/Img/Img';
import { useAppSelector } from '../../../../redux/store';
// import { USERS_SETTINGS } from '../../../../routes/routeConstants';

const Banner = () => {
  const navigate = useNavigate();
  const { authData } = useAppSelector((state) => state.auth);

  const inst = authData?.institutionName;

  const slides = [
    {
      title: inst,
      message:
        "To ensure the best experience for all users, we require the completion of your profile before accessing our platform's features and benefits.",
      action: 'Complete profile',
    },
    {
      title: inst,
      message:
        "To ensure the best experience for all users, we require the completion of your profile before accessing our platform's features and benefits.",
      action: 'Complete profile',
    },
  ];

  // const isProfileIncomplete = [
  //   authData?.firstName,
  //   authData?.lastName,
  //   authData?.occupation,
  //   authData?.birthday,
  //   authData?.phone,
  //   authData?.email,
  //   authData?.state,
  //   authData?.country,
  //   authData?.yearsOfExperience, // assuming this is already a string or you convert it
  //   authData?.bio,
  //   authData?.governmentId,
  // ].some((field) => !field);

  // const staticSlides = isProfileIncomplete
  //   ? slides.slice(0, 1)
  //   : authData?.tier === 'TIER 2'
  //   ? slides.slice(1, 2)
  //   : [];

  const [currentSlide, setCurrentSlide] = useState(0);

  // const bannerNotifications = useAppSelector(
  //   (state) => state.bannerNotifications.notifications
  // );

  // const combinedSlides = [
  //   ...staticSlides,
  //   ...bannerNotifications.map((notification) => ({
  //     title: 'Notification',
  //     message: notification.message,
  //     action: notification.metadata.link,
  //   })),
  // ];

  const totalSlides = slides.length;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % totalSlides);
    }, 9000);
    return () => clearInterval(interval);
  }, [totalSlides]);

  return (
    <Container>
      {slides.map((slide, index) => (
        <Slide key={index} className={index === currentSlide ? 'active' : ''}>
          <ContentWrapper>
            <TextArea>
              <Header1>{slide.title}</Header1>
              <p>{slide.message}</p>
              <FooterContent>
                <Navigation
                  onClick={() => {
                    if (
                      slide.action === 'Complete profile' ||
                      slide.action === 'Complete Verification'
                    ) {
                      navigate(`/`, {
                        replace: true,
                        state: { data: '' },
                      });
                    } else {
                      navigate(slide.action);
                    }
                  }}
                >
                  {slide.action}
                  <Img src="/static/svg/bulletIcon.svg" alt="icon" />
                </Navigation>
              </FooterContent>
            </TextArea>
            <ImageArea>
              <Img
                src="/static/svg/doctorAndPatient.svg"
                alt="doctor examining patient"
              />
            </ImageArea>
          </ContentWrapper>
        </Slide>
      ))}
    </Container>
  );
};

export default Banner;

const Container = styled.section`
  border-radius: 0.625rem;
  display: flex;
  justify-content: space-between;
  color: white;
  background: ${({ theme }) => theme.palette.mainBlue};
  position: relative;
  width: 100%;
  height: 14rem;
  overflow: hidden;

  @media (max-width: 768px) {
  }

  @media (max-width: 480px) {
    // padding: 2.12rem 1rem;
    height: 12rem;
  }

  @media (max-width: 390px) {
  }
`;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 30rem;
  width: 100%;
  font-size: 1.125rem;
  gap: 0.5rem;

  @media (max-width: 768px) {
  }

  @media (max-width: 480px) {
    & > p {
      font-size: 14px;
      font-weight: 300;
      line-height: 20.93px;
      max-width: 21rem;
    }
  }

  @media (max-width: 390px) {
  }
`;

const Header1 = styled.p`
  font-weight: 300;
  font-size: 1.5rem;

  @media (max-width: 768px) {
  }

  @media (max-width: 480px) {
    font-size: 16px;
    font-weight: 500;
    line-height: 23.92px;
  }

  @media (max-width: 390px) {
  }
`;

const Navigation = styled.div`
  display: flex;
  gap: 0.5rem;
  color: ${({ theme }) => theme.palette.stateColorYellow};
  font-weight: 500;
  cursor: pointer;

  & > img {
    width: 24px;
  }
`;

const ImageArea = styled.div`
  position: absolute;
  right: 3.13rem;
  bottom: 0;
  z-index: -1;
  opacity: 40%;

  @media (max-width: 884px) {
    display: none;
  }
`;

const FooterContent = styled.div`
  display: flex;
  gap: 0.5rem;
  color: ${({ theme }) => theme.palette.white};
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 18px;
    font-weight: 500;
  }
`;

const Slide = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 0;
  width: 100%;
  opacity: 0;
  transform: translateX(100%);
  transition: opacity 0.4s ease, transform 1.5s ease;

  height: 100%;
  padding: 2.125rem 3.125rem;

  &.active {
    opacity: 1;
    transform: translateX(0);
    z-index: 10;
  }

  &:not(.active) {
    transform: translateX(-100%);
    opacity: 0;
    z-index: 0;
  }

  @media (max-width: 480px) {
    padding: 2.12rem 1rem;
    height: 12rem;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
